import { useMutation, UseMutationResult } from 'react-query';
import { CreateGroupLinkDto, UsersApi } from '../../../api-client';
import { UseMutationOptions } from 'react-query/types/react/types';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';

export type addUserVariables = {
  userId: string,
  groupId: string,
};

type UseAddUserToGroup = (
  usersApi: UsersApi,
  options?: Omit<
    UseMutationOptions<AxiosResponse<CreateGroupLinkDto>, ErrorResponse, addUserVariables>,
    'mutationFn'
    >,
) => UseMutationResult<AxiosResponse<CreateGroupLinkDto>, ErrorResponse, addUserVariables>;

export const useAddUserToGroup: UseAddUserToGroup = (
  usersApi,
  options,
) => {
  const tenantId = localStorage.getItem('tenantId') as string;
  return useMutation(
    ({ userId, groupId }) => usersApi.createUserGroupLink(tenantId, userId, {
      userGroupDocumentId: groupId
    }),
    options,
  );
};
